import dayjs from 'dayjs';
import { NotificationModuleType } from 'src/app/models/notification/notification-module-type';
import {
  NotificationWorkItemDto,
  NotificationWorkItemSubType
} from 'src/app/models/notification/notification-work-item-dto';
import { WorkItemDtoStatusMapping } from 'src/app/models/work/work-item-dto-status';

export class NotificationWorkItemWrapper {
  initialNotification: NotificationWorkItemDto;
  selected: boolean;
  deleted: boolean;

  id: string;
  createdTime: string;
  moduleType: NotificationModuleType;
  read: boolean;
  userId: number;
  workItemId: number;
  oldStatus: number;
  newStatus: number;
  processId: number;
  processName: string;
  activityId: number;
  activityName: string;
  taskId: number;
  taskName: string;
  clientId: number;
  clientName: string;
  dueDate: string;

  comment: string;
  sourceUserName: string;
  subType: NotificationWorkItemSubType;

  time: string;
  title: string;
  message: string;

  static wrap(
    notification: NotificationWorkItemDto
  ): NotificationWorkItemWrapper {
    const result = new NotificationWorkItemWrapper();

    result.initialNotification = notification;

    result.id = notification.id;
    result.createdTime = notification.createdTime;
    result.moduleType = notification.moduleType;
    result.read = notification.read;
    result.userId = notification.userId;
    result.workItemId = notification.workItemId;
    result.oldStatus = notification.oldStatus;
    result.newStatus = notification.newStatus;
    result.processId = notification.processId;
    result.processName = notification.processName;
    result.activityId = notification.activityId;
    result.activityName = notification.activityName;
    result.taskId = notification.taskId;
    result.taskName = notification.taskName;
    result.clientId = notification.clientId;
    result.clientName = notification.clientName;
    result.dueDate = notification.dueDate;
    result.comment = notification.comment;
    result.sourceUserName = notification.sourceUserName;
    result.subType = notification.subType;

    result.time = dayjs(result.createdTime).format('YYYY-MM-DD HH:mm:ss');

    const dueDate = dayjs(result.dueDate).format('YYYY-MM-DD');

    if (result.subType === NotificationWorkItemSubType.TaggedUser) {
      result.title = `For client ${result.clientName} and process ${result.processName} | ${result.activityName} | ${result.taskName}`;
      result.message = `Comment added for work-item ${result.taskName} with due date ${dueDate}. Comment: ${result.comment}`;
    } else if (result.subType === NotificationWorkItemSubType.UpdateStatus) {
      const newStatus = WorkItemDtoStatusMapping.statusNumberToString(
        result.newStatus
      );
      result.title = `For client ${result.clientName} and process ${result.processName} | ${result.activityName} | ${result.taskName}`;
      result.message = `Status changed to ${newStatus} for work-item ${result.taskName} with due date ${dueDate}`;
    } else if (result.subType === NotificationWorkItemSubType.QaUpdated) {
      result.title = `For client ${result.clientName} and process ${result.processName} | ${result.activityName} | ${result.taskName}`;
      result.message = result.comment; //`Status changed to ${newStatus} for work-item ${result.taskName} with due date ${dueDate}`
    } else if (result.subType === NotificationWorkItemSubType.AdHocCreated) {
      result.title = 'Work item created by checklist action';
      result.message = `A checklist has triggered the creation of a work-item from ${result.processName} | ${result.activityName} | ${result.taskName} 
      where you are the designated responsible for the client ${result.clientName}`;
    }

    return result;
  }
}
